<template>
  <b-card
    class="card-transaction"
    no-body
  >
    <b-card-header>

      <b-card-title>Últimas Negociações</b-card-title>
        
      <b-card-text class="font-small-2">
          <b-card-text class="font-small-2">
            <b-button
              class="font-small-2" 
              variant="outline-primary" 
              size="sm"
              :to="{ name: 'negociacoes'}"
            >
              Ver mais
            </b-button>
          </b-card-text>
        </b-card-text>

    </b-card-header>

    <b-card-body>

      <div 
        v-if="!negociacoes.length"
        class="d-flex justify-content-center align-items-center text-center pt-2 pb-2" 
        style="height: 100%;"
      >
        <div>
          <feather-icon
            size="30"
            icon="MessageSquareIcon"
          />
          <h5 class="mt-1">Você ainda não negociou nenhum hit</h5>
          <small>As suas negociações mais recentes serão exibidas aqui</small>
        </div>
      </div>

      <div
        v-for="negociacao in negociacoes"
        :key="negociacao.id"
        class="transaction-item"
      >
        <b-media no-body>
          <b-media-aside>
            <b-avatar
              rounded
              size="42"
              :variant="negociacaoStatusCor(negociacao.statusNegociacaoValor)"
            >
              <feather-icon
                size="18"
                :icon="negociacaoStatusIcone(negociacao.statusNegociacaoValor)"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="transaction-title">
              {{ negociacao.hitNomeComposicao }}
            </h6>
            <small>#{{ negociacao.id }}</small>
          </b-media-body>
        </b-media>
        <div
          class="font-weight-bolder"
        >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :to="{ name: 'negociacao-visualizar', params: { id: negociacao.id } }"
          size="sm"
        >
          <feather-icon
            icon="EyeIcon"
          />
        </b-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BCardHeader, BCardTitle, BCardText, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar, BDropdown, BDropdownItem, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useJwt from '@/auth/jwt/useJwt'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BButton,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BImg,
  },
  data() {
    return {
      negociacoes: {},

      page: 0,
      size: 5,
      sort: 'DESC',
    }    
  },
  created() {
    this.negociacoesLista()
  },
  methods: {

    negociacaoStatusCor(status) {
      if (status == '0') return 'light-secondary'
      if (status == '1' || status == '2') return 'light-success'
      if (status == '3' || status == '4') return 'light-danger'
      return 'light-secondary'
    },

    negociacaoStatusIcone(status) {
      if (status == '0') return 'MessageSquareIcon'
      if (status == '1' || status == '2') return 'CheckIcon'
      if (status == '3' || status == '4') return 'DeleteIcon'
      return 'MessageSquareIcon'
    },

    negociacoesLista() {

      useJwt.propostasLista({
        page: this.page,
        size: this.size,
        sort: this.sort,
      })
        .then(response => {
          //console.log( response.data.content );

          this.negociacoes = response.data.content
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
        })
    },

  }
}
</script>
